import React from 'react';
import { Document, Image, Page, StyleSheet, Text, View, pdf } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: { backgroundColor: 'white', flexDirection: 'column', padding: '14pt' },
    greenBox: {
        borderWidth: 2,
        borderColor: '#2E8B00',
        borderStyle: 'solid',
        borderRadius: 4,
        padding: 10,
        marginTop: 4,
    },
    sectionHeader: {
        fontSize: 8,
        fontWeight: 'bold',
        marginTop: 6,
        marginBottom: 2,
    },
    sectionDivider: {
        borderBottomWidth: 0.5,
        borderBottomColor: '#dddddd',
        borderBottomStyle: 'solid',
        marginBottom: 4,
    },
    row: { flexDirection: 'row', marginBottom: 3 },
    cell: { flex: 1 },
    fieldText: { fontSize: 8 },
    labelInline: { fontSize: 8, color: '#555555' },
    valueInline: { fontSize: 8, fontWeight: 'bold' },
    sign: { width: '150pt', height: '100pt', marginTop: '5pt' },
    footer: {
        backgroundColor: '#2E8B00',
        color: 'white',
        textAlign: 'center',
        padding: 22,
        borderRadius: 4,
        marginTop: 10,
        fontSize: 10,
    },
});

const PdfField = ({ label, value }) => (
    <View style={{ marginBottom: 3 }}>
        <Text style={styles.fieldText}>
            <Text style={styles.labelInline}>{label}: </Text>
            <Text style={styles.valueInline}>{value || ''}</Text>
        </Text>
    </View>
);

const PdfCheckItem = ({ label, checked }) => (
    <View style={{ marginBottom: 3 }}>
        <Text style={styles.fieldText}>
            <Text style={styles.labelInline}>{label}: </Text>
            <Text style={styles.valueInline}>{checked ? 'Sí' : 'No'}</Text>
        </Text>
    </View>
);

const PdfClauses = ({ label, checked }) => (
    <View style={{ marginBottom: 3 }}>
        <Text style={styles.fieldText}>
            <Text style={styles.labelInline}>{label}: </Text>
            <Text style={styles.valueInline}>{checked ? 'Acepto' : 'No Acepto'}</Text>
        </Text>
    </View>
);

const SectionHeader = ({ title }) => (
    <View>
        <Text style={styles.sectionHeader}>{title}</Text>
        <View style={styles.sectionDivider} />
    </View>
);

const logoIberdrolaSvg = '<svg width="170" height="38" viewBox="0 0 170 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M59.9152 8.91553H56.9453V29.0947H59.9152V8.91553Z" fill="#00A443"></path><path d="M73.7654 15.1292C72.745 14.4818 71.558 14.1461 70.3497 14.163C69.2543 14.163 68.3221 14.3887 67.5533 14.8401C66.7947 15.2827 66.1485 15.8945 65.6651 16.6278C65.5693 16.78 65.478 16.9245 65.3913 17.0766V8.91553H62.5659V29.0962H65.3913V26.4869C65.4734 26.639 65.5602 26.779 65.6514 26.919C66.1288 27.6573 66.7763 28.2704 67.5396 28.7067C68.3165 29.1581 69.2532 29.3837 70.3497 29.3837C71.2642 29.3938 72.1697 29.2021 73.0016 28.8223C73.8075 28.4478 74.5286 27.913 75.121 27.2507C75.7458 26.5466 76.2302 25.7296 76.5481 24.8437C76.9027 23.8594 77.0784 22.8196 77.067 21.7734C77.067 20.2742 76.7693 18.9556 76.1739 17.8176C75.6255 16.7224 74.7939 15.7941 73.7654 15.1292ZM73.8521 23.8928C73.651 24.4814 73.3362 25.0247 72.9255 25.4918C72.5406 25.9282 72.0628 26.2729 71.5273 26.5006C70.9614 26.7373 70.353 26.8554 69.7396 26.8475C68.4524 26.8475 67.3955 26.4007 66.5689 25.5071C65.7422 24.6135 65.3289 23.3689 65.3289 21.7734C65.3164 21.0496 65.4286 20.3291 65.6606 19.6433C65.8628 19.0604 66.1759 18.522 66.5826 18.058C66.9659 17.6232 67.4444 17.2827 67.9808 17.0629C68.5397 16.8382 69.1373 16.7255 69.7396 16.7313C71.047 16.7313 72.1121 17.1735 72.9347 18.058C73.7573 18.9425 74.1706 20.1819 74.1747 21.7764C74.1878 22.4951 74.0788 23.2107 73.8521 23.8928Z" fill="#00A443"></path><path d="M88.8138 15.1003C87.7619 14.4667 86.5529 14.1419 85.3251 14.1631C84.3528 14.1509 83.3878 14.3319 82.486 14.6956C81.6397 15.0463 80.8782 15.5738 80.2525 16.2429C79.6058 16.9358 79.11 17.7554 78.7965 18.6499C78.4479 19.6554 78.277 20.7139 78.2914 21.778C78.2914 23.2995 78.5987 24.6302 79.2134 25.7703C79.7969 26.8784 80.6745 27.8044 81.7496 28.4466C82.8766 29.1048 84.1633 29.4391 85.4681 29.4127C86.3029 29.4143 87.1335 29.2928 87.9329 29.0521C88.7353 28.8102 89.4805 28.4086 90.1238 27.8714C90.8235 27.2786 91.4056 26.5597 91.84 25.752L89.6491 24.3964C89.3765 24.945 89.0052 25.4386 88.5536 25.8525C88.1452 26.2191 87.6633 26.4945 87.1402 26.6604C86.5981 26.8269 86.0337 26.9095 85.4666 26.9053C84.688 26.9182 83.9206 26.7188 83.2468 26.3287C82.5746 25.9214 82.0387 25.3235 81.707 24.611C81.3896 23.9271 81.2072 23.1883 81.17 22.4353H92.0712C92.0907 22.3018 92.1004 22.167 92.1001 22.0321V21.6563C92.1001 20.1571 91.807 18.8456 91.2207 17.7218C90.6756 16.6426 89.8426 15.7354 88.8138 15.1003ZM82.2548 17.8967C82.5992 17.4536 83.0512 17.1059 83.5678 16.8865C84.1156 16.6605 84.7036 16.5482 85.2962 16.5563C85.8347 16.5417 86.3697 16.648 86.8618 16.8673C87.3539 17.0867 87.7906 17.4135 88.1398 17.8237C88.6682 18.4323 89.0075 19.2686 89.1576 20.3326H81.2536C81.297 20.0649 81.3569 19.8002 81.4332 19.5399C81.6016 18.9455 81.8803 18.3881 82.2548 17.8967Z" fill="#00A443"></path><path d="M101.556 14.1631H100.719C99.8974 14.1505 99.0901 14.3813 98.399 14.8264C97.7164 15.2636 97.1636 15.9386 96.7407 16.8515V14.4506H93.9214V29.0962H96.7452V21.2835C96.7452 20.0349 97.0627 19.0353 97.6977 18.2847C97.9882 17.9255 98.3568 17.6371 98.7754 17.4415C99.1941 17.2459 99.6517 17.1482 100.114 17.1558H101.556V14.1631Z" fill="#00A443"></path><path d="M113.201 17.0766C113.114 16.9245 113.025 16.7724 112.927 16.6278C112.444 15.8945 111.798 15.2827 111.039 14.8401C110.271 14.3877 109.349 14.162 108.272 14.163C107.354 14.154 106.446 14.3408 105.606 14.7108C104.791 15.0754 104.065 15.6115 103.476 16.2824C102.856 16.9876 102.376 17.8045 102.063 18.6894C101.715 19.6799 101.545 20.7238 101.559 21.7734C101.559 23.2725 101.852 24.5937 102.437 25.7368C102.981 26.8311 103.812 27.7567 104.842 28.4146C105.868 29.0601 107.059 29.3951 108.272 29.3792C109.349 29.3792 110.276 29.1535 111.054 28.7021C111.815 28.2659 112.462 27.6546 112.939 26.919C113.031 26.779 113.116 26.6345 113.198 26.4869V29.0962H116.023V8.91553H113.201V17.0766ZM112.034 25.4918C111.646 25.9306 111.163 26.2755 110.622 26.5006C110.06 26.7346 109.457 26.8526 108.848 26.8475C107.541 26.8475 106.476 26.4007 105.653 25.5071C104.831 24.6135 104.417 23.3689 104.413 21.7734C104.401 21.0496 104.513 20.3291 104.745 19.6433C104.948 19.0603 105.261 18.522 105.668 18.058C106.051 17.6225 106.53 17.2819 107.067 17.0629C107.635 16.8364 108.241 16.7237 108.853 16.7313C110.14 16.7313 111.197 17.1735 112.025 18.058C112.853 18.9425 113.266 20.1819 113.264 21.7764C113.272 22.4948 113.162 23.2097 112.939 23.8928C112.749 24.4817 112.441 25.0257 112.034 25.4918Z" fill="#00A443"></path><path d="M126.318 14.1631H125.483C124.661 14.1505 123.854 14.3813 123.162 14.8264C122.48 15.2636 121.927 15.9386 121.504 16.8515V14.4506H118.679V29.0962H121.504V21.2835C121.504 20.0349 121.821 19.0353 122.455 18.2847C122.746 17.9246 123.116 17.6358 123.536 17.4401C123.955 17.2445 124.414 17.1472 124.877 17.1558H126.318V14.1631Z" fill="#00A443"></path><path d="M137.562 15.1139C136.389 14.4653 135.067 14.1373 133.727 14.163C132.721 14.1535 131.722 14.3395 130.786 14.7108C129.899 15.0655 129.094 15.6006 128.424 16.2824C127.744 16.9739 127.213 17.7979 126.866 18.7031C126.492 19.683 126.306 20.7246 126.318 21.7734C126.318 23.2725 126.64 24.5987 127.284 25.752C127.901 26.8784 128.819 27.8113 129.936 28.4465C131.101 29.1016 132.42 29.4351 133.756 29.4126C134.764 29.4222 135.764 29.2313 136.697 28.8512C137.581 28.4883 138.384 27.9541 139.06 27.2795C139.741 26.5944 140.271 25.7746 140.617 24.8726C140.992 23.8831 141.178 22.8317 141.164 21.7734C141.164 20.2519 140.843 18.9211 140.2 17.7811C139.583 16.6658 138.67 15.7428 137.562 15.1139ZM137.936 23.9065C137.729 24.4995 137.403 25.0441 136.979 25.507C136.576 25.9388 136.085 26.2778 135.538 26.5006C134.961 26.7353 134.344 26.8532 133.721 26.8474C132.916 26.8574 132.124 26.647 131.43 26.2389C130.741 25.8233 130.185 25.2194 129.828 24.4983C129.432 23.7396 129.235 22.8313 129.236 21.7734C129.224 21.0496 129.336 20.329 129.568 19.6433C129.772 19.0578 130.09 18.5189 130.505 18.058C130.902 17.6196 131.395 17.279 131.946 17.0629C132.515 16.8397 133.122 16.7272 133.734 16.7313C134.557 16.7166 135.37 16.927 136.083 17.3398C136.773 17.7525 137.333 18.3522 137.697 19.0697C138.091 19.8203 138.289 20.7236 138.289 21.7795C138.296 22.5036 138.177 23.2236 137.936 23.9065Z" fill="#00A443"></path><path d="M145.993 26.1706C145.753 25.8724 145.633 25.4443 145.633 24.8865V8.91113H142.808V25.0675C142.79 25.7928 142.938 26.5124 143.241 27.1717C143.528 27.7669 143.991 28.2601 144.566 28.5851C145.238 28.9493 145.994 29.1283 146.757 29.104H148.343V26.624H147.189C146.632 26.6164 146.234 26.4688 145.993 26.1706Z" fill="#00A443"></path><path d="M161.436 17.3342C161.093 16.6319 160.596 16.0162 159.982 15.5328C159.364 15.055 158.658 14.7026 157.905 14.4951C157.103 14.2709 156.273 14.1593 155.44 14.1635C154.193 14.1442 152.962 14.4471 151.866 15.0429C150.8 15.6388 149.966 16.5783 149.502 17.7085L151.722 18.9819C151.991 18.2938 152.47 17.7081 153.091 17.3083C153.715 16.9026 154.479 16.6997 155.383 16.6997C156.029 16.6911 156.67 16.8089 157.271 17.0466C157.832 17.2717 158.31 17.6643 158.64 18.171C158.987 18.6903 159.16 19.3724 159.16 20.2174V21.8499C159.061 21.7449 158.955 21.6414 158.842 21.5456C157.939 20.7585 156.632 20.3649 154.922 20.3649C153.899 20.3516 152.883 20.5275 151.924 20.8838C151.083 21.1856 150.344 21.72 149.794 22.425C149.29 23.1447 149.018 24.0016 149.015 24.8805C149.012 25.7594 149.279 26.618 149.779 27.3408C150.317 28.035 151.035 28.5685 151.854 28.8836C152.786 29.2489 153.78 29.4297 154.78 29.4161C156.509 29.4161 157.845 29.0079 158.788 28.1913C158.978 28.0259 159.152 27.8425 159.306 27.6436V29.0996H161.987V19.9572C162.011 19.0519 161.822 18.1536 161.436 17.3342ZM158.208 26.6151C157.517 27.0208 156.655 27.2237 155.621 27.2237C154.564 27.2237 153.684 27.0208 152.983 26.6151C152.282 26.2094 151.932 25.6231 151.932 24.8563C151.917 24.487 152.008 24.1211 152.194 23.8018C152.38 23.4826 152.654 23.2234 152.983 23.0549C153.684 22.6603 154.564 22.4635 155.621 22.4646C156.659 22.4646 157.521 22.6674 158.208 23.0731C158.531 23.2435 158.8 23.5013 158.983 23.8172C159.167 24.1331 159.258 24.4942 159.246 24.8593C159.246 25.6282 158.9 26.2139 158.208 26.6166V26.6151Z" fill="#00A443"></path><path d="M30.3413 21.9242C30.3379 24.2464 31.2529 26.4756 32.8867 28.1257C36.0392 31.2782 40.3191 31.2721 43.047 29.7902C46.3866 27.9781 53.8996 22.5435 46.0991 0C46.0991 10.6411 30.3413 11.7229 30.3413 21.9242Z" fill="#FF9C1A"></path><path d="M37.5162 9.3159C36.9989 6.52707 36.1697 3.67128 34.9297 0C34.9297 10.6411 19.1704 11.7229 19.1704 21.9242C19.1668 24.2458 20.0806 26.4748 21.7128 28.1257C24.8652 31.2782 29.1786 31.2691 31.8731 29.7902C25.6077 23.1095 27.8138 15.3759 37.5162 9.3159Z" fill="#0DA9FF"></path><path d="M26.3458 9.3159C25.8285 6.52707 24.9978 3.67128 23.7593 0C23.7593 10.6411 8 11.7229 8 21.9242C8 27.1566 12.2388 29.46 12.2388 29.46C11.5801 32.2576 11.4424 35.1526 11.8326 38L13.8546 37.6638C12.8656 34.2253 13.4727 30.4809 13.5351 30.1143C16.1216 31.1504 18.7887 30.843 20.7027 29.7932C14.4282 23.1095 16.6434 15.3774 26.3458 9.3159Z" fill="#00A443"></path></svg>';

const svgToPngBase64 = (svgString) => new Promise((resolve, reject) => {
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const img = new window.Image();
    img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 340;
        canvas.height = 76;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, 340, 76);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('SVG load failed')); };
    img.src = url;
});


const RegisterLeadPdfDocument = ({ values, documents, checks, clauses, logoPng }) => {
    const docType = documents.find(d => d.idEvent === values.documentType);
    const singleHomeLabel = values.singleFamilyHome === true ? 'Sí' : values.singleFamilyHome === false ? 'No' : '';

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {logoPng && <Image key="logo-iberdrola" src={logoPng} style={{ width: 120, height: 34, display: 'block', marginBottom: 8 }} />}

                <Text style={{ fontSize: 10, marginBottom: 6 }}>
                    Estimado/a {values.name},
                </Text>

                <Text style={{ fontSize: 10, marginBottom: 6 }}>
                    Muchas gracias por el interés mostrado en Iberdrola. Próximamente contactaremos con usted para continuar con el proceso.
                </Text>

                <Text style={{ fontSize: 10, marginBottom: 6 }}>
                    A continuación se observan los datos que han sido completados:
                </Text>

                <View style={styles.greenBox}>
                    <SectionHeader title="Datos Personales" />
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Nombre" value={values.name} />
                        </View>
                        <View style={styles.cell}>
                            <PdfField label="Teléfono" value={values.phone} />
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Primer Apellido" value={values.surname1} />
                        </View>
                        <View style={styles.cell}>
                            <PdfField label="Email" value={values.email} />
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Segundo Apellido" value={values.surname2} />
                        </View>
                        <View style={styles.cell}>
                            <PdfField label="Vivienda Unifamiliar" value={singleHomeLabel} />
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Tipo de Documento" value={docType ? docType.showName : ''} />
                        </View>
                        <View style={styles.cell}>
                            <PdfField label="Documento" value={values.document} />
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Código Postal" value={values.codigoPostal} />
                        </View>
                        <View style={styles.cell} />
                    </View>

                    <SectionHeader title="Interesado en:" />
                    {Array.from({ length: Math.ceil(checks.length / 2) }, (_, i) => (
                        <View key={i} style={styles.row}>
                            {checks.slice(i * 2, i * 2 + 2).map((check) => {
                                const checkValue = values.checks[check.id];
                                const isChecked = checkValue && checkValue.interestedCheckValue &&
                                    checkValue.interestedCheckValue.value === 'SI';
                                return (
                                    <View key={check.id} style={styles.cell}>
                                        <PdfCheckItem label={check.description} checked={!!isChecked} />
                                    </View>
                                );
                            })}
                            {checks.slice(i * 2, i * 2 + 2).length < 2 && <View style={styles.cell} />}
                        </View>
                    ))}

                    <SectionHeader title="Datos de Contrato" />
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Compañía" value={values.company} />
                        </View>
                        <View style={styles.cell}>
                            <PdfField label="Titular del contrato" value={values.contractHolder} />
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Franja horaria" value={values.franjas} />
                        </View>
                        <View style={styles.cell}>
                            <PdfCheckItem label="Llamar Ya" checked={!!values.callNow} />
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Stand" value={values.stand ? values.stand.mall : ''} />
                        </View>
                        <View style={styles.cell} />
                    </View>

                    <SectionHeader title="Tarjeta regalo" />
                    <View style={styles.row}>
                        <View style={styles.cell}>
                            <PdfField label="Código tarjeta regalo" value={values.cardbono} />
                        </View>
                        <View style={styles.cell} />
                    </View>

                    <SectionHeader title="Observaciones" />
                    <View style={{ marginBottom: 5 }}>
                        <View style={styles.cell}>
                            <PdfField label="Observaciones" value={values.observations} />
                        </View>
                    </View>

                    <SectionHeader title="Cláusulas de Privacidad" />
                    {Array.from({ length: Math.ceil(clauses.length / 2) }, (_, i) => (
                        <View key={i} style={styles.row}>
                            {clauses.slice(i * 2, i * 2 + 2).map((clause) => {
                                const clauseValue = values.clauses[clause.id];
                                const isChecked = clauseValue && clauseValue.privacyClauseValue &&
                                    clauseValue.privacyClauseValue.value === 'SI';
                                return (
                                    <View key={clause.id} style={styles.cell}>
                                        <PdfClauses label={clause.description} checked={!!isChecked} />
                                    </View>
                                );
                            })}
                            {clauses.slice(i * 2, i * 2 + 2).length < 2 && <View style={styles.cell} />}
                        </View>
                    ))}
                </View>

                <Text style={{ fontSize: 10, marginTop: 8, marginBottom: 8 }}>
                    Un cordial saludo.
                </Text>

                <View style={styles.footer}>
                    <Text>© 2026 Iberdrola, S.A.U. Reservados todos los derechos.</Text>
                </View>
            </Page>
        </Document>
    );
};

const blobToBase64 = (blob) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
});

export const generateLeadPdfBase64 = async (values, documents, checks, clauses) => {
    const logoPng = await svgToPngBase64(logoIberdrolaSvg);
    const blob = await pdf(
        <RegisterLeadPdfDocument
            values={values}
            documents={documents}
            checks={checks}
            clauses={clauses}
            logoPng={logoPng}
        />
    ).toBlob();
    return blobToBase64(blob);
};
